// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"4c5115f8","299":"838244e9","311":"e6802520","319":"3fe7eb12","350":"a8313bf8","615":"d8f30a83","800":"bceeb599"}[chunkId] + ".chunk.js";
};